<div class="row p-t-25">
    <app-card [showHeader]="false" padding="16">
        <app-base-form-create-tools></app-base-form-create-tools>
        <ng-content></ng-content>
    </app-card>
</div>